import React from 'react';

import { Skeleton } from '@mui/material';

import CommitForm from '../../../components/CommitForm';
import ContentCard from '../../../components/ContentCard';
import {
  useUpdateExamMarkingRequestMutation,
} from '../../../services/exams';
import { ExamMarkingRequest } from '../../../services/exams/types';
import useError from '../../../utils/react/hooks/useError';

interface RequestDetailsCardProps {
  request?: ExamMarkingRequest,
}

const RequestDetailsCard = ({
  request,
}: RequestDetailsCardProps) => {
  const [updateMarkingRequest, {
    isError: isUpdateMarkingRequestError,
    error: updateMarkingRequestError,
    isLoading: isUpdateMarkingRequestLoading,
  }] = useUpdateExamMarkingRequestMutation();

  useError(isUpdateMarkingRequestError, updateMarkingRequestError);

  if (!request) {
    return (
      <ContentCard title="Request Details" variant="contained">
        <Skeleton variant="rectangular" height={120} />
      </ContentCard>
    );
  }

  return (
    <ContentCard title="Request Details" variant="contained">
      <CommitForm
        data={request}
        metadata={{
          creationDatetime: {
            label: 'Created at',
            editable: false,
            type: 'datetime',
          },
          dueDatetime: {
            label: 'Due',
            editable: true,
            type: 'datetime',
          },
        }}
        fields={{
          creationDatetime: {
            xs: 12,
            md: 12,
          },
          dueDatetime: {
            xs: 12,
            md: 12,
          },
        }}
        onSubmit={(changes) => updateMarkingRequest({
          requestId: request.requestId,
          newAttributes: changes,
        })}
        isSubmitLoading={isUpdateMarkingRequestLoading}
        autoSubmit
      />
    </ContentCard>
  );
};

export default RequestDetailsCard;
